import { UseMutationResult, useMutation } from "@tanstack/react-query";

import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { GeneralResponse, Token } from "../../../types/api";
import { IChangePasswordRequest } from "../../../types/apis/auth-apis";

export const ChangePassword = async (
  payload: IChangePasswordRequest,
  token: Token,
): Promise<GeneralResponse> => {
  try {
    const response = await Api<
      IChangePasswordRequest,
      GeneralResponse<IChangePasswordRequest>
    >({
      method: Methods.POST,
      endpoint: EndPoints.changePassword,
      body: payload,
      token,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useChangePassword = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    {
      payload: IChangePasswordRequest;
      token: Token;
    }
  > = useMutation({
    mutationKey: ["change_password"],
    mutationFn: ({ payload, token }) => ChangePassword(payload, token),
    ...options,
  });
  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
